import { type Key, memo, useState } from 'react';

import type { OrganizationUnitListFormValues } from './OrganizationUnitLists.types.ts';

import OrganizationUnitLists from './OrganizationUnitLists';
import { useService } from './OrganizationUnitLists.hooks.ts';
import { getOrganizationUnitListData } from './OrganizationUnitLists.helpers.ts';

export const OrganizationUnitListsContainer = () => {
  const [selectedOrganizationUnitListKeys, setSelectedOrganizationUnitListKeys] = useState<Key[]>(
    [],
  );
  const [openOrganizationUnitListDrawer, setOpenOrganizationUnitListDrawer] =
    useState<boolean>(false);
  const [organizationUnitListId, setOrganizationUnitListId] = useState<number | null>(null);
  const { createMutation, updateMutation, deleteMutation, units, isLoading } = useService({
    organizationUnitListId,
  });

  const handleOpenOrganizationUnitListDrawer = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    id: number | null,
  ) => {
    if (event) event.preventDefault();
    if (id === undefined) return;

    setOrganizationUnitListId(id);
    setOpenOrganizationUnitListDrawer(true);
  };

  const handleCloseOrganizationUnitListDrawer = () => {
    setOrganizationUnitListId(null);
    setOpenOrganizationUnitListDrawer(false);
  };

  const handleSubmitOrganizationUnitList = (values: OrganizationUnitListFormValues) => {
    const data = getOrganizationUnitListData(values);
    if (values?.id) {
      updateMutation.mutate({ data: { ...data, id: values.id } });
      handleCloseOrganizationUnitListDrawer();
      return;
    }
    createMutation.mutate(data);
    handleCloseOrganizationUnitListDrawer();
  };

  const handleDeleteOrganizationUnitLists = () => {
    const params = { ids: selectedOrganizationUnitListKeys.map((key: Key) => Number(key)) };
    setOrganizationUnitListId(null);
    setSelectedOrganizationUnitListKeys([]);
    deleteMutation.mutate(params);
  };

  return (
    <OrganizationUnitLists
      organizationUnitLists={units}
      isLoading={isLoading}
      openOrganizationUnitListDrawer={openOrganizationUnitListDrawer}
      onOpenOrganizationUnitListDrawer={handleOpenOrganizationUnitListDrawer}
      onCloseOrganizationUnitListDrawer={handleCloseOrganizationUnitListDrawer}
      onSubmitOrganizationUnitList={handleSubmitOrganizationUnitList}
      selectedOrganizationUnitListKeys={selectedOrganizationUnitListKeys}
      setSelectedOrganizationUnitListKeys={setSelectedOrganizationUnitListKeys}
      onDeleteOrganizationUnitLists={handleDeleteOrganizationUnitLists}
      organizationUnitListId={organizationUnitListId}
      itemsToDeleteCount={selectedOrganizationUnitListKeys.length}
    />
  );
};

export default memo(OrganizationUnitListsContainer);
